import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { AchievementPlayerDialogComponent } from "../achievement-player-dialog/achievement-player-dialog.component";

@NgModule({
    declarations: [AchievementPlayerDialogComponent],
    exports: [AchievementPlayerDialogComponent],
    imports: [CommonModule, MatButtonModule, FlexModule, FlexLayoutModule, MatIconModule, TranslateModule]
})
export class AchievementPlayerDialogModule {}
